module.exports = __webpack_public_path__ + "static/media/lamina16actividad.bb2a4b83.png";